// extracted by mini-css-extract-plugin
export default {"container":"LogoUploader_styles_container__GHxfz","deleteButtonContainer":"LogoUploader_styles_deleteButtonContainer__YnBq0","inner":"LogoUploader_styles_inner__Rk0li"};